// extracted by mini-css-extract-plugin
var _1 = "LayoutListElement_item__98de0";
var _2 = "LayoutListElement_root__22ba1";
export { _1 as "item", _2 as "root" }
